// Runs the callback when the intro animations start, right away when start-intro is already set
export function onStartIntro(callback) {
    if (document.body.classList.contains('start-intro')) {
        callback();
        return;
    }

    document.addEventListener('startintro', callback, { once: true });
}

// Homepage intro: plays the lottie on a fullscreen panel, folds it up and then sets start-intro
class IntroOverlay {
    constructor() {
        this.el = document.querySelector('[data-intro-overlay]');
        if (!this.el) return;

        document.documentElement.classList.add('intro-overlay-active');

        const container = this.el.querySelector('.intro-overlay-lottie');
        const data = container.querySelector('script[type="application/json"]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (typeof lottie == 'undefined' || !data || reducedMotion) {
            this.finish();
            return;
        }

        const animation = lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: false,
            autoplay: true,
            animationData: JSON.parse(data.textContent)
        });

        data.remove();

        // Fold up 1.7s before the lottie ends
        const closeOffset = 1.7;
        animation.addEventListener('enterFrame', () => {
            if (this.closing) return;
            if (animation.currentFrame >= animation.totalFrames - closeOffset * animation.frameRate) {
                this.close();
            }
        });
        animation.addEventListener('data_failed', () => this.finish());
    }

    close() {
        this.closing = true;
        const onTransitionEnd = (event) => {
            if (event.target !== this.el) return;
            this.el.removeEventListener('transitionend', onTransitionEnd);
            this.remove();
        };
        this.el.addEventListener('transitionend', onTransitionEnd);
        this.el.classList.add('is-closing');

        // Start the intro animations 0.8s before the panel is fully folded up (the fold takes 1s, see intro-overlay.scss)
        setTimeout(() => this.startIntro(), 200);
    }

    finish() {
        this.remove();
        this.startIntro();
    }

    remove() {
        document.documentElement.classList.remove('intro-overlay-active');
        this.el.remove();
    }

    startIntro() {
        document.body.classList.add('start-intro');
        document.dispatchEvent(new CustomEvent('startintro'));
    }
}

new IntroOverlay();
